// This code is from esp-web-flasher by NabuCasa and Adafruit

const lut = {
    b: { 
        u: DataView.prototype.getInt8, 
        p: DataView.prototype.setInt8, 
        bytes: 1 
    },
    B: {
        u: DataView.prototype.getUint8,
        p: DataView.prototype.setUint8,
        bytes: 1,
    },
    h: {
        u: DataView.prototype.getInt16,
        p: DataView.prototype.setInt16,
        bytes: 2,
    },
    H: {
        u: DataView.prototype.getUint16,
        p: DataView.prototype.setUint16,
        bytes: 2,
    },
    i: {
        u: DataView.prototype.getInt32,
        p: DataView.prototype.setInt32,
        bytes: 4,
    },
    I: {
        u: DataView.prototype.getUint32,
        p: DataView.prototype.setUint32,
        bytes: 4,
    },
    l: {
        u: DataView.prototype.getInt32,
        p: DataView.prototype.setInt32,
        bytes: 4,
    },
    L: {
        u: DataView.prototype.getUint32,
        p: DataView.prototype.setUint32,
        bytes: 4,
    },
    q: {
        // @ts-ignore
        u: DataView.prototype.getInt64,
        // @ts-ignore
        p: DataView.prototype.setInt64,
        bytes: 8,
    },
    Q: {
        // @ts-ignore
        u: DataView.prototype.getUint64,
        // @ts-ignore
        p: DataView.prototype.setUint64,
        bytes: 8,
    },
    s: {
        u: DataView.prototype.getUint8,
        p: DataView.prototype.setUint8,
        bytes: 1,
    }
};

export const pack = (format: string, ...data: number[]) => {
    let pointer = 0;
    if (format.replace(/[<>]/, "").length !== data.length) {
        throw new Error("Pack format to Argument count mismatch");
    }
    let bytes: number[] = [];
    let littleEndian = true;
    for (let i = 0; i < format.length; i++) {
        if (format[i] === "<") {
            littleEndian = true;
        } else if (format[i] === ">") {
            littleEndian = false;
        } else {
            pushBytes(format[i], data[pointer]);
            pointer++;
        }
    }

    function pushBytes(formatChar: string, value: number) {
        if (!(formatChar in lut)) {
            throw new Error("Unhandled character '" + formatChar + "' in pack format");
        }
        // @ts-ignore
        let dataSize = lut[formatChar].bytes;
        let view = new DataView(new ArrayBuffer(dataSize));
        // @ts-ignore
        let dataViewFn = lut[formatChar].p.bind(view);
        dataViewFn(0, value, littleEndian);
        for (let i = 0; i < dataSize; i++) {
            bytes.push(view.getUint8(i));
        }
    }

    return bytes;
};

export const unpack = (format: string, bytes: Uint8Array) => {
    let pointer = 0;
    let data: Array<number | string> = [];
    let littleEndian = true;
    let strLen = 0;

    for (let c of format) {
        if (c === "<") {
            littleEndian = true;
        } else if (c === ">") {
            littleEndian = false;
        } else if ((c.charCodeAt(0) >= 48) && (c.charCodeAt(0) <= 57)) {
            strLen = (c.charCodeAt(0) - 48) + strLen * 10;
        } else {
            pushData(c, strLen);
            strLen = 0;
        }
    }

    function pushData(formatChar: string, strLen: number) {
        if (!(formatChar in lut)) {
            throw new Error("Unhandled character '" + formatChar + "' in unpack format");
        }
        // @ts-ignore
        let dataSize = lut[formatChar].bytes;
        if (strLen === 0) {
            let view = new DataView(new ArrayBuffer(dataSize));
            for (let i = 0; i < dataSize; i++) {
                view.setUint8(i, bytes[pointer + i] & 0xff);
            }
            // @ts-ignore
            let dataViewFn = lut[formatChar].u.bind(view);
            data.push(dataViewFn(0, littleEndian));
            pointer += dataSize;
        } else {
            let str = "";
            for (let i = 0; i < strLen; i++) {
                const ch = String.fromCharCode(bytes[pointer + i] & 0xff);
                if ((ch.charCodeAt(0) > 32) && (ch.charCodeAt(0) < 127)) {
                    str += ch;
                }
            }
            data.push(str);
            pointer += strLen;
        }
    }

    return data;
};
